import { render } from "./CampaignsSkeleton.vue?vue&type=template&id=4dc1ba71"
import script from "./CampaignsSkeleton.vue?vue&type=script&lang=js"
export * from "./CampaignsSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__